import React, {Fragment} from 'react';
import image from "../../assets/img/Logo/1.png";
import {Link} from "react-router-dom";
import {logoutAdmin} from "../../actions/auth";
import {connect} from "react-redux";

const CommanSidebar = ({user}) => {
    const location = window.location.pathname;
    console.log(location);
    return (
        <Fragment>
            <div className="sidebar-new">
                <div className="logo-image-small">
                    <img src={image}/>
                </div>
                <Link className={`${location === "/admin-profile" ? 'active' : ''}`} to="/admin-profile"><i
                    className="fa fa-user"/> {user && user.name}</Link>
                {/*<Link className={`${location === "/permission" ? 'active' : ''}`} to="/permission"><i*/}
                    {/*className="fa fa-key"/>Permission</Link>*/}
                <Link className={`${location === "/permission-info" ? 'active' : ''}`} to="/permission-info"><i
                    className="fa fa-key"/>Permission Info</Link>
                <Link className={`${location === "/users" || location === "/add-user" ? 'active' : ''}`} to="/admin"><i
                    className="fa fa-user"/> Users</Link>
                <Link className={`${location === "/groups" ? 'active' : ''}`} to="/groups"><i
                    className="fa fa-users"/>Groups</Link>
                <Link to={'/admin'} onClick={() => {
                    localStorage.removeItem('vip_token_admin');
                    window.location.href = '/admin';
                    logoutAdmin()
                }} className="dropdown-item"><i className="fa fa-lock"/> Logout</Link>
            </div>
        </Fragment>
    );
};

const mapStateToProps = (state) => ({
    isAuthenticatedAdmin: state.auth.isAuthenticatedAdmin,
    user: state.auth.user
});
export default connect(mapStateToProps, {logoutAdmin})(CommanSidebar);
